export default __webpack_public_path__ + "static/chat-security-55b0fee4ae12a7f548f2e2544f476a0f.png";